export default function AGB() {
    return (
        <div data-testid="agb-page" className="bg-aimploy-bg">
            <section className="pt-24 lg:pt-32 pb-12 bg-aimploy-bg relative overflow-hidden">
                <div className="absolute -top-40 -right-40 h-[400px] w-[400px] rounded-full bg-aimploy-violet/10 blur-3xl" />
                <div className="relative max-w-[900px] mx-auto px-6 lg:px-12">
                    <span className="text-xs uppercase tracking-[0.2em] text-aimploy-violet font-semibold">Rechtliches</span>
                    <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-bold leading-[0.95] tracking-tight mt-6">
                        AGB
                    </h1>
                    <p className="text-aimploy-muted mt-6 max-w-2xl">
                        Allgemeine Geschäftsbedingungen der aimploy UG (haftungsbeschränkt). Stand: April 2026.
                    </p>
                </div>
            </section>

            <section className="pb-24 lg:pb-32 bg-aimploy-bg">
                <div className="max-w-[900px] mx-auto px-6 lg:px-12">
                    <div className="bg-white rounded-3xl p-8 lg:p-12 border border-black/5 space-y-10">
                        <Section title="§ 1 Geltungsbereich" k="agb.1">
                            <p>
                                (1) Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen der
                                aimploy UG (haftungsbeschränkt) (im Folgenden „aimploy") und ihren Auftraggebern
                                (im Folgenden „Kunden") über die Erbringung von Personalvermittlungs- und
                                Recruiting-Dienstleistungen.
                            </p>
                            <p>
                                (2) Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, aimploy
                                stimmt ihrer Geltung ausdrücklich schriftlich zu.
                            </p>
                        </Section>

                        <Section title="§ 2 Vertragsschluss" k="agb.2">
                            <p>
                                (1) Angebote von aimploy sind freibleibend. Ein Vertrag kommt erst durch schriftliche
                                Auftragsbestätigung von aimploy oder durch Aufnahme der Tätigkeit zustande.
                            </p>
                            <p>
                                (2) Im Anbahnungsprozess übermittelte Kandidatenprofile sind streng vertraulich zu
                                behandeln.
                            </p>
                        </Section>

                        <Section title="§ 3 Leistungen von aimploy" k="agb.3">
                            <p>
                                aimploy schuldet die Suche, Identifikation, Ansprache und Vorstellung geeigneter Kandidaten
                                für die vom Kunden zu besetzende Position. aimploy schuldet ausdrücklich keinen
                                Vermittlungserfolg, sofern nicht im Einzelvertrag eine Erfolgsvergütung vereinbart wurde.
                            </p>
                        </Section>

                        <Section title="§ 4 Mitwirkungspflichten des Kunden" k="agb.4">
                            <p>
                                Der Kunde stellt aimploy alle für eine erfolgreiche Vermittlung erforderlichen Informationen
                                rechtzeitig und vollständig zur Verfügung (insb. Anforderungsprofil, Vergütungsstruktur,
                                Unternehmenshistorie, Ansprechpartner für Interviews).
                            </p>
                        </Section>

                        <Section title="§ 5 Vergütung" k="agb.5">
                            <p>
                                (1) Die Vergütung richtet sich nach der individuellen Vereinbarung im Einzelvertrag
                                (Erfolgshonorar oder Retainer-Modell).
                            </p>
                            <p>
                                (2) Bei Erfolgshonoraren entsteht der Anspruch mit Vertragsunterzeichnung des vermittelten
                                Kandidaten. Sämtliche Beträge verstehen sich zzgl. der gesetzlichen Umsatzsteuer.
                            </p>
                            <p>
                                (3) Rechnungen sind binnen 14 Tagen nach Zugang ohne Abzug zur Zahlung fällig.
                            </p>
                        </Section>

                        <Section title="§ 6 Vertraulichkeit & Abwerbeverbot" k="agb.6">
                            <p>
                                Beide Parteien verpflichten sich zur strengen Vertraulichkeit über alle im Rahmen der
                                Zusammenarbeit erlangten Informationen. Der Kunde verpflichtet sich, von aimploy
                                vorgestellte Kandidaten nicht ohne Mitteilung an aimploy einzustellen oder an Dritte
                                weiterzuleiten.
                            </p>
                        </Section>

                        <Section title="§ 7 Haftung" k="agb.7">
                            <p>
                                (1) aimploy haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie nach den
                                Vorschriften des Produkthaftungsgesetzes. Bei leichter Fahrlässigkeit haftet aimploy nur
                                bei Verletzung wesentlicher Vertragspflichten und begrenzt auf den vertragstypisch
                                vorhersehbaren Schaden.
                            </p>
                            <p>
                                (2) Eine Haftung für Schäden, die aus der Auswahl oder dem Verhalten eines vermittelten
                                Kandidaten beim Kunden entstehen, ist ausgeschlossen, soweit gesetzlich zulässig.
                            </p>
                        </Section>

                        <Section title="§ 8 Datenschutz" k="agb.8">
                            <p>
                                Beide Parteien verarbeiten personenbezogene Daten gemäß DSGVO. Details siehe
                                Datenschutzerklärung.
                            </p>
                        </Section>

                        <Section title="§ 9 Schlussbestimmungen" k="agb.9">
                            <p>
                                (1) Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts.
                            </p>
                            <p>
                                (2) Erfüllungsort und Gerichtsstand ist, soweit zulässig, Herford.
                            </p>
                            <p>
                                (3) Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen
                                Bestimmungen unberührt.
                            </p>
                        </Section>

                        <p className="text-xs text-aimploy-muted pt-6 border-t border-black/5">
                            Hinweis: Diese AGB sind ein vorformuliertes Muster und müssen vor produktivem Einsatz
                            durch einen Rechtsanwalt geprüft und an Ihren konkreten Geschäftsbetrieb angepasst werden.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <div>
            <h2 className="font-display text-2xl font-bold mb-4">{title}</h2>
            <div className="text-sm text-aimploy-muted leading-relaxed space-y-3">
                {children}
            </div>
        </div>
    );
}
